export const CUSTOMER_APPLICATIONS_DEFAULT_STATUS_FILTER = 'all'
export const REVIEW_CENTER_DEFAULT_STATUS_FILTER = 'all'
export const CUSTOMER_MANAGEMENT_DEFAULT_FILING_FILTER = 'all'

export const CUSTOMER_APPLICATIONS_PAGE_SIZE = 5
export const REVIEW_CENTER_PAGE_SIZE = 5
export const CUSTOMER_MANAGEMENT_PAGE_SIZE = 5
export const B2B_PAGE_SIZE_OPTIONS = [5, 10, 20] as const
export type B2bPageSize = (typeof B2B_PAGE_SIZE_OPTIONS)[number]

export function getB2bPageCount(rows: { length: number }, pageSize: number) {
  return Math.max(1, Math.ceil(rows.length / pageSize))
}

export function paginateB2bRows<T>(rows: T[], currentPage: number, pageSize: number) {
  const safePage = Math.max(1, currentPage)
  const startIndex = (safePage - 1) * pageSize
  return rows.slice(startIndex, startIndex + pageSize)
}
